import { AxiosInstance } from 'axios';
import { AbsenceCategoriesRepository } from '@/model/repository/shift/AbsenceCategoriesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AbsenceCategoriesRepository => ({
    index() {
      return Repository.get(`${resource}`);
    },
    show(id: string) {
      return Repository.get(`${resource}/${id}`);
    },
    create(payload) {
      return Repository.post(`${resource}`, payload);
    },
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
  });
